import type { NextPage } from 'next'
import styles from './UserSC.module.scss'
import ComponentHeader from 'componentsUnits/componentHeader'
import UserComponent from './userComponent'
import Subtitle from 'componentsUnits/subtitle'
import { Type } from 'types/type'
import { Size } from 'types/size'
import { PublicProfile } from 'types/publicProfile'

interface Props {
  title?: string
  profiles: PublicProfile[]
  hideFollowButton?: boolean
}
const UsersScrollComponent: NextPage<Props> = (props: Props) => {
  return (
    <div className={styles.container}>
      {props.title && <ComponentHeader title={props.title} />}
      <div className={styles.component_list_wrapper}>

        {
          props.profiles?.length > 0
            ? <>
              {props.profiles.map((p, i: number) => (
                <UserComponent
                  key={i}
                  id={p.id}
                  image={p.image}
                  name={p.name}
                  hideFollowButton />
              ))}
            </>
            : <Subtitle type={Type.t1} size={Size.xSmall} text={`No profiles were found`} />
        }
      </div>
    </div>
  )
}

export default UsersScrollComponent
